module.exports = __webpack_public_path__ + "img/t1-1.03df398d.svg";